import { Item } from "react-use-cart";
import { Activeproduct } from "./Company";

export interface AddProductResponse {
  success: boolean;
  message: string | null;
}

export interface PendingOrderResponse {
  hasPendingOrder: boolean;
  order: WebShopOrder | null;
}


export interface WebShopOrder {
  webShopOrderId: number
  webShopProducts: WebshopProducts
  userId: number
  companyId: string
  organizationNumber: string
  user: OrderUser
  created: string
}

export interface WebShopOrderResponse {
  success: boolean
  message: string
  order?: WebshopOrderModel
}

export interface WebshopProducts {
  logo: Logo
}

export interface Logo {
  productId: number
  publicUrlTransform: string
  publicUrl: string
  publicId: string

}

export interface OrderUser {
  userId: number
  phoneNumber: string
  name: string
  userRef: string
  email: string
}


export interface GetProductsResponse {
  productDefinitions: WebshopProductModel[]
}

export interface ApplyCouponResponse {
  couponCode: string
  success: boolean
  productDefinitions: WebshopProductModel[]
}

export interface WebshopOrderModel {
  id: string
  documentId: string
  orgNr: string
  email: string
  products: WebshopProductModel[]
  couponCode?:string
}

/// NEW WEBSHOP
export interface WebshopProductModel extends Item {
  webShopProductId: number
  basePrice: number
  documentId: string
  description: string
  linkText: string
  path: string
  name: string
  payload: string
}

export interface LogoProductModel extends WebshopProductModel {
  img: string
}
export interface BulletpointsProductModel extends WebshopProductModel {
  bulletpoints: string[]
}

export interface InfotextProductModel extends WebshopProductModel {
  infotext: string
}

export interface ExtraLinksProductModel extends WebshopProductModel {
  extraLinks: ExtraLink[]
}

export interface ExtraLink {
  label: string
  url: string
}

export type ProductProps = {
  handleAddProduct: (product: WebshopProductModel | null) => void
  handleFormValidation: (valid: boolean) => void
  initialProduct: WebshopProductModel | null
}

export type ProductPromoProps = {
  name: string
  path: string
  companyId: string
  description: string
  linkText: string
  overrideLink?: boolean
  isActive?: boolean
}



// Product Configurations

export interface GetProductConfigurationsResponse {
  logo?: LogoConfigModel;
  extraLinks?: ExtraLinksConfigWrapper;
  infoText?: InfoTextConfigModel;
  bulletPoints?: BulletPointsConfigModel;
  searchWords?: SearchWordsConfigModel;
}


export interface FlattenedProductConfigurationsResponse {
  logo?: LogoConfigModel;
  extraLinks?: ExtraLinksConfigModel[];
  infoText?: InfoTextConfigModel;
  bulletPoints?: BulletPointsConfigModel;
  searchWords?: SearchWordsConfigModel;
}


export interface UpdateConfigurationRequest {
  documentId: string
  logo?: LogoConfigModel
  extraLinks?: ExtraLinksConfigWrapper
  infoText?: InfoTextConfigModel
  bulletPoints?: BulletPointsConfigModel
  searchWords?: SearchWordsConfigModel
}

export interface UpdateConfigurationResponse {

}

export interface UpdateProductConfigRequest {
  id: string
  payload: string
}

export interface SaleStatusResponse {
  customerNotFound: boolean
  orderStatuses: OrderStatus[]
}

export interface OrderStatus {
  saleId:number
  saleStatus:SaleStatus
  productPublished:boolean
  createdOn: string
  activeProducts: Activeproduct[]
  isMinBedriftSale: boolean
}

export enum SaleStatus {
  "Under behandling" = 2,
  "Ferdig behandlet" = 5  
} 

export const WebshopId = {
  logo: 101,
  bulletPoints: 102,
  infoText: 103,
  extraLink: 104,
  searchWords: 105
};

export interface CheckCompanyForSaleResponse {
  allowed:boolean
  ReasonWhyNotAllowed: string
}



export type ProductConfigProps<T extends ProductConfigModel = ProductConfigModel> = {
  handleOnChange: (config: T[]) => void;
  handleFormValidation: (valid: boolean) => void;
  config: T[];
};


export interface ProductConfigModel {
  crmPublishLineId: string
  crmProductId: string
}

export interface LogoConfigModel extends ProductConfigModel {
  publicUrlTransform: string
}

export interface InfoTextConfigModel extends ProductConfigModel {
  text: string
}

export interface BulletPointsConfigModel extends ProductConfigModel {
  bulletPoints: string[]
}

export interface ExtraLinksConfigWrapper {
  extraLinks: ExtraLinksConfigModel[]
}

export interface ExtraLinksConfigModel extends ProductConfigModel {
  url: string
  label: string
}

export interface SearchWordsConfigModel extends ProductConfigModel {
  searchWords: string
}